<template>
  <section class="orders">
    <section class="tabs">
      <div class="tabs-item" :class="{ active: tab === 'market', unread: marketUnread > 0 }">
        <template v-if="tab === 'market'">音乐购买</template>
        <router-link to="/orders/market" replace v-else>音乐购买</router-link>
      </div>
      <div class="tabs-item" :class="{ active: tab === 'post', unread: postUnread > 0 }">
        <template v-if="tab === 'post'">人工修音</template>
        <router-link to="/orders" replace v-else>人工修音</router-link>
      </div>
      <div class="tabs-item" :class="{ active: tab === 'studio', unread: studioUnread > 0 }">
        <template v-if="tab === 'studio'">其他订单</template>
        <router-link to="/orders/studio" replace v-else>其他订单</router-link>
      </div>
    </section>
    <section class="listing">

      <van-list v-model="marketLoading" :finished="marketFinished" :immediate-check="false" @load="marketRefresh" v-if="tab === 'market'" ref="marketList">
        <ul>
          <template v-if="marketListing.length">
            <li v-for="(item, index) in marketListing" :key="index">
              <a :href="`/njwap/chanpin/music-market/index/main#/orderdetail/${item.orderid}?curuserid=${$curuserid}&token=${$token}`">
                <div class="hd">
                  <div class="order-id">
                    订单号：CB{{ item.orderid }}
                  </div>
                  <div class="status">
                    {{ item.order_status_text }}
                  </div>
                </div>

                <div class="bd">
                  <div class="title">
                    <h2>{{ item.songname }}</h2>
                    <div class="song">
                      独家永久买断
                    </div>
                    <div class="song no">
                      不支持退款
                    </div>
                    <div class="money" v-if="item.status == 0">
                      <p>
                        金额：<strong>¥{{ item.price }}</strong>
                      </p>
                    </div>
                    <div class="money" v-else-if="item.status != 4">
                      <p>
                        实付金额：<strong>¥{{ item.paymoney }}</strong>
                      </p>
                    </div>
                    <div class="word" v-if="item.recommend_word">{{ item.recommend_word }}</div>
                  </div>
                  <div class="pic">
                    <cover :data-src="item.uploader_photo | replaceUrlProtocol" class="lazyload" :alt="item.songname" />
                  </div>
                </div>
              </a>

              <div class="ft" v-if="item.status == 0 || item.status == 2 || item.status == 5">
                <a :href="`/njwap/chanpin/music-market/index/main#/orderdetail/${item.orderid}?curuserid=${$curuserid}&token=${$token}`" class="btn primary" v-if="item.status == 0">继续付款</a>
                <template v-if="item.status == 2 || item.status == 5">
                  <a :href="`/njwap/chanpin/music-market/index/main#/lyric/${item.songid}?curuserid=${$curuserid}&token=${$token}`" class="btn">查看歌曲</a>
                  <a :href="`/njwap/chanpin/music-market/index/main#/editsong?songid=${item.songid}&orderid=${item.orderid}&curuserid=${$curuserid}&token=${$token}`" class="btn">入库发行</a>
                  <a class="btn primary"
                     :href="{
                       ac: 'marketrecord',
                       songid: item.songid,
                       orderid: item.orderid,
                       clksrc: '音乐超市_订单列表_录原唱'
                     } | appProtocolUrl">
                    去演唱
                  </a>
                </template>
              </div>
            </li>
          </template>
          <li class="empty" v-else>
            暂无内容
          </li>
        </ul>
      </van-list>

      <van-list v-model="postLoading" :finished="postFinished" :immediate-check="false" @load="postRefresh" v-else-if="tab === 'post'" ref="postList">
        <ul>
          <template v-if="postListing.length">
            <li v-for="(item, index) in postListing" :key="index">
              <router-link :to="`/order/${item.orderid}`">
                <div class="hd">
                  <div class="order-id">
                    订单号：CB{{ item.orderid }}
                  </div>
                  <div class="status">
                    {{ item.status_text }}
                  </div>
                </div>

                <div class="bd">
                  <!-- 修音品类 -->
                  <template v-if="item.product_info.service_class == 1">
                    <div class="title">
                      <h2>{{ item.product_info.name }}</h2>
                      <div class="song">
                        {{ item.work.songname }}
                      </div>
                      <div class="money">
                        <p>
                          总价：<strong>¥{{ item.money_detail.pay_money }}</strong>
                        </p>
                      </div>
                    </div>
                    <div class="pic">
                      <cover :data-src="item.work.cover | avatar(100)" class="lazyload" :alt="item.work.songname" />
                    </div>
                  </template>
                  <!-- 音乐教学品类 -->
                  <template v-else-if="item.product_info.service_class == 2">
                    <div class="title">
                      <h2>{{ item.product_info.name }}</h2>
                      <div class="money">
                        <p>
                          总价：<strong>¥{{ item.money_detail.pay_money }}</strong>
                        </p>
                      </div>
                    </div>
                    <div class="pic">
                      <img :data-src="item.product_info.other_attribute.icon" :alt="item.product_info.name" class="lazyload" v-if="item.product_info.other_attribute">
                    </div>
                  </template>
                </div>
              </router-link>

              <div class="ft" v-if="item.status == 0 || item.status == 3 || item.status == 5 || item.status == 6">
                <template v-if="item.status == 0">
                  <van-count-down class="time" :time="item.create_time | restTime">
                    <template #default="timeData">
                      <template v-if="timeData.hours === 0 && timeData.minutes === 0 && timeData.seconds === 0">
                        已超时
                      </template>
                      <template v-else>
                        剩余: {{ timeData.hours }}时{{ timeData.minutes }}分{{ timeData.seconds }}秒
                      </template>
                    </template>
                  </van-count-down>
                  <router-link class="btn primary" :to="`/order/${item.orderid}`">继续付款</router-link>
                </template>
                <a class="btn primary"
                   :href="{
                     ac: 'music_publish',
                     orderid: item.orderid,
                     songname: item.work.songname,
                     songcover: item.work.cover
                   } | appProtocolUrl" v-if="item.product_info.service_class == 1 && item.status == 6">
                  发布
                </a>
                <p class="reason" v-if="item.status == 3">
                  {{ item.desc }}
                </p>
                <p class="reason" v-if="item.status == 5">
                  {{ item.desc }}
                </p>
              </div>
            </li>
          </template>
          <li class="empty" v-else>
            暂无内容
          </li>
        </ul>
      </van-list>

      <van-list v-model="studioLoading" :finished="studioFinished" :immediate-check="false" @load="studioRefresh" v-else-if="tab === 'studio'" ref="studioList">
        <ul>
          <template v-if="studioListing.length">
            <li v-for="(item, index) in studioListing" :key="index">
              <router-link :to="`/studio/order/${item.id}`">
                <div class="hd">
                  <div class="order-id">
                    订单号：CB{{ item.id }}
                  </div>
                  <div class="status">
                    {{ item.status_text }}
                  </div>
                </div>

                <div class="bd">
                  <div class="title">
                    <h2>{{ item.spuInfo.name }}</h2>
                    <h3 v-if="item.song.name">{{ item.song.name }}</h3>
                    <div class="song">
                      <span v-for="(attr, key) in item.attribute_snapshot" :key="key">
                        {{ attr.value[0].name }};
                      </span>
                    </div>
                    <div class="money">
                      <p>
                        总价：<strong>¥{{ item.money_detail.product_money }}</strong>
                      </p>
                    </div>
                  </div>
                  <div class="pic">
                    <cover :data-src="item.spuInfo.banner_img && item.spuInfo.banner_img[0]" class="lazyload" :alt="item.spuInfo.name" />
                  </div>
                </div>
              </router-link>

              <div class="ft" v-if="item.status == 0 || item.status == 3 || item.status == 5 || item.status == 6">
                <template v-if="item.status == 0">
                  <van-count-down class="time" :time="item.create_time | restTime">
                    <template #default="timeData">
                      <template v-if="timeData.hours === 0 && timeData.minutes === 0 && timeData.seconds === 0">
                        已超时
                      </template>
                      <template v-else>
                        剩余: {{ timeData.hours }}时{{ timeData.minutes }}分{{ timeData.seconds }}秒
                      </template>
                    </template>
                  </van-count-down>
                  <router-link class="btn primary" :to="`/studio/order/${item.id}`">继续付款</router-link>
                </template>
              </div>
            </li>
          </template>
          <li class="empty" v-else>
            暂无内容
          </li>
        </ul>
      </van-list>

    </section>

    <section class="bottom-line">
      <p>我是有底线的</p>
    </section>

    <div class="float-btn" @click="handleFloatBtn" v-if="tab === 'post'">
      <div class="icon">
        <img src="~@cdn_img/nav-3.svg" alt="">
      </div>
      <div class="text">优惠券</div>
    </div>

    <!-- <mall-float-navigator /> -->
    <div class="orders-dialog" v-if="isShowPop && tab === 'market'">
      <div class="content">
        <img class="content-img" :src="IMGURL" />
        <div class="content-save" @click="onSave"></div>
        <div class="content-close" @click="onClose"></div>
      </div>
    </div>
  </section>
</template>

<script>
import Cover from '../components/Cover';
// import MallFloatNavigator from '../components/FloatNavigator';
// import status from '../order-status';
// import { enums } from '@module/helper/filters';
import localStorage from '../local-storage';
import dayjs from 'dayjs';
import { track } from '@changba/funny'

export default {
  name: 'Orders',

  components: {
    Cover
  },

  filters: {
    // orderStatus(value) {
    //   return enums(value, status);
    // },
    restTime(value) {
      return dayjs(value).add(15, 'minute') - dayjs();
    }
  },

  // beforeRouteLeave(to, from, next) {
  //   document.removeEventListener("visibilitychange", this.gotoOrders);
  //   next()
  // },

  props: {
    tab: {
      type: String,
      default: 'post'
    }
  },

  data() {
    return {
      IMGURL: 'https://res.cdn.changbaimg.com/!/chanpin/mall/bg_market_dialog_new.png',
      postListing: [],
      postPage: 1,
      postLoading: false,
      postFinished: false,

      marketListing: [],
      marketPage: 1,
      marketLoading: false,
      marketFinished: false,

      studioListing: [],
      studioPage: 1,
      studioLoading: false,
      studioFinished: false,

      postUnread: 0,
      marketUnread: 0,
      studioUnread: 0,
      isShowPop: true
    }
  },

  watch: {
    tab(val) {
      this.init(val);
    }
  },
  mounted() {
    track("show_pop", {
      content: '保存图片弹窗展示'
    })
    document.addEventListener("visibilitychange", this.gotoOrders);
  },

  activated() {
    this.postUnread = localStorage.getItem('changba-music-mall-home-unread');

    this.init(this.tab);
  },

  methods: {
    handleFloatBtn() {
      window.location.href = `/njwap/chanpin/mall/index/main/coupons?curuserid=${this.$curuserid}&token=${this.$token}`
    },
    gotoOrders() {
      console.log('--visibilitychange--', this.$route.path)
      if (document.hidden) {
        return
      }
      if (/\/orders/.test(this.$route.path || '')) {
        this.init(this.tab);
      }
    },
    init(tab) {
      if (tab === 'post') {
        this.postPage = 1;
        this.postListing = [];
        this.postLoading = false;
        this.postFinished = false;

        // 标记所有订单为已读
        localStorage.setItem('changba-music-mall-home-unread', '0');
        this.postUnread = 0;

        this.$nextTick(() => {
          this.$refs.postList.check();
        });
      }
      else if (tab === 'market') {
        this.marketPage = 1;
        this.marketListing = [];
        this.marketLoading = false;
        this.marketFinished = false;

        this.$nextTick(() => {
          this.$refs.marketList.check();
        });
      }
      else if (tab === 'studio') {
        this.studioPage = 1;
        this.studioListing = [];
        this.studioLoading = false;
        this.studioFinished = false;

        this.studioUnread = 0;

        this.$nextTick(() => {
          this.$refs.studioList.check();
        });
      }
    },

    async postRefresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getOrderList', {
        data: {
          page: this.postPage,
          size: 10
        }
      });

      this.$toast.clear();

      this.postLoading = false;

      // 为解决客户端一个怪异不渲染的问题
      if (this.postPage == 1) {
        window.scrollTo(0, -1);
      }

      if (code === 1) {
        this.postPage++;

        if (data.length > 0) {
          this.postListing.push(...data);

          if (data.length < 10) {
            this.postFinished = true;
          }
        }
        else {
          this.postFinished = true;
        }
      }
      else {
        this.postFinished = true;
      }
    },

    async marketRefresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/newversion/musicFair/getMyOrderList', {
        data: {
          page: this.marketPage,
          num: 10
        }
      });

      this.$toast.clear();

      this.marketLoading = false;

      // 为解决客户端一个怪异不渲染的问题
      if (this.marketPage == 1) {
        window.scrollTo(0, -1);
      }

      if (code === 1) {
        this.marketPage++;

        if (data.length > 0) {
          this.marketListing.push(...data);

          if (data.length < 10) {
            this.marketFinished = true;
          }
        }
        else {
          this.marketFinished = true;
        }
      }
      else {
        this.marketFinished = true;
      }
    },

    async studioRefresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicStore/musicmall/getOrderList', {
        data: {
          page: this.studioPage,
          size: 10
        }
      });

      this.$toast.clear();

      this.studioLoading = false;

      // 为解决客户端一个怪异不渲染的问题
      if (this.studioPage == 1) {
        window.scrollTo(0, -1);
      }

      if (code === 1) {
        this.studioPage++;

        if (data.list.length > 0) {
          this.studioListing.push(...data.list);

          if (data.list.length < 10) {
            this.studioFinished = true;
          }
        }
        else {
          this.studioFinished = true;
        }
      }
      else {
        this.studioFinished = true;
      }
    },
    onSave() {
      track("save_img", {
        content: '保存图片'
      })
      location.href = 'changba://?ac=saveImage&imageURL=' + encodeURIComponent(this.IMGURL)
      this.isShowPop = false
    },
    onClose() {
      track("close_dialog", {
        content: '关闭保存图片弹窗'
      })
      this.isShowPop = false
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/orders.scss";
.orders {
  &-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);
    .content {
      position: relative;
      width: 345px;
      height: 393px;
      &-img {
        width: 100%;
      }
      &-save {
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 173px;
        height: 63px;
        background-image: url('../assets/btn_save.png');
        background-size: 100% 100%;
      }
      &-close {
        position: absolute;
        bottom: -64px;
        left: 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 32px;
        background-image: url('../assets/btn_close.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>
